<script>
import moment from 'jalali-moment'

export default {
  props: {
    enDate: {
      type: String,
      required: true,
    },
    enFormat: {
      type: String,
      required: false,
      default: 'YYYY/MM/DD HH:mm:ss',
    },
    faFormat: {
      type: String,
      required: false,
      default: 'YYYY/MM/DD HH:mm',
    },
  },

  // eslint-disable-next-line vue/component-api-style
  methods: {
    jalaliDate() {
      return moment.from(this.enDate, 'en', this.enFormat).locale('fa').format(this.faFormat)
    },
  },
}
</script>

<template>
  <span
    class="date jalali-date d-inline-flex"
    style="direction: ltr"
  >
    {{ jalaliDate() }}
  </span>
</template>
